import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import SpecialistList from '../components/Specialists/SpecialistList';
import EditSpecialist from '../components/Specialists/EditSpecialist';
import ViewSpecialist from '../components/Specialists/ViewSpecialist';

const Specialists = () => {
  return (
    <Routes>
      <Route path="/" element={<SpecialistList />} />
      <Route path="/edit/:id" element={<EditSpecialist />} />
      <Route path="/edit" element={<EditSpecialist />} />
      <Route path="/view/:id" element={<ViewSpecialist />} />
    </Routes>
  )
}

export default Specialists;